
import { mapGetters } from 'vuex'

import card from '~/mixins/card'
import { attachmentHref, isAttachmentExcludedBy } from '~/util/files'
export default {
    mixins: [card],
    computed: {
        ...mapGetters([
            'summaryAttachments'
        ]),
    },
    methods: {
        // drschoice/flow#615: links go through the API, never the S3 bucket.
        attachmentHref,
        isAttachmentExcluded (attachment) {
            return isAttachmentExcludedBy(attachment, this.card_config_value?.excluded)
        },
    }
}
